<valg-table *ngIf="partyStatus.length > 0"
            [columnDefinition]="partyStatusColumnDef"
            [data]="partyStatus"
            [itemName]="'election_overview.party_status.table.item_name' | translate"
            [title]="'election_overview.party_status.title' | translate"
            [hasPagination]="false"
            [displayItemCount]="false"
            [hasMainActionButton]="false">
            <h2 class="m-0 text--f20 text--500">{{ 'election_overview.party_status.title' | translate }}</h2>
            <valg-dk-result-summary content-position="pre-table" [resultSummary]="resultSummary"></valg-dk-result-summary>
</valg-table>
<valg-card-information-content *ngIf="candidateDataLoadState === CandidateDataLoadState.NotLoaded"
                               [title]="'election_overview.party_status.title' | translate"
                               [message]="'election_overview.party_status.not_released' | translate">
</valg-card-information-content>
<valg-card-information-content *ngIf="candidateDataLoadState === CandidateDataLoadState.Revoked"
                               [title]="'election_overview.party_status.title' | translate"
                               [message]="'election_overview.party_status.revoked' | translate">
</valg-card-information-content>

